<template>
    <div class="container">
        <div class="row">
            <div class="col-12 mb-5">
                <h4 class="text-center" v-if="noSearchResults">Har du svårt att hitta det du söker? Här kommer några
                    tips på hur du kan söka och
                    filtrera.</h4>
                <h2 class="text-center mt-5" v-else>Söktips</h2>
            </div>
            <div class="col-12 col-md-6 mb-3">
                <div class="card">
                    <div class="card-header">
                        <h4>Vem</h4>
                    </div>
                    <div class="card-body">
                        <div>Du kan söka på personen du önskar information om.</div>
                        <div class="font-italic mb-2"> Exempel: Eva Timm</div>

                        <div>Du kan söka på vem som har lagt upp informationen.</div>
                        <div class="font-italic mb-2"> Exempel: Köpings museum, Sala hembygds- och fornminnesförening
                        </div>

                        <div>Du kan filtrera på vem som har laddat upp material. Vi har sex olika typer av
                            källor: arkiv, forskare, förening och organisation, museum, myndighet och privatperson.
                        </div>
                        <div class="font-italic mb-2"> Exempel: Du kan välja att enbart se material som museum laddat
                            upp.
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6 mb-3">
                <div class="card">
                    <div class="card-header">
                        <h4>Vad</h4>
                    </div>
                    <div class="card-body">
                        <div>Du kan filtrera på vilken typ av material du vill se. Vi har fem olika
                            materialtyper: platser, artiklar, bilder, filmer och dokument.
                        </div>
                        <div class="font-italic mb-2">Exempel: Du kan välja att enbart visa bilder på Tomas
                            Tranströmer
                        </div>

                        <div>Du kan filtrera på vilket ämne du vill se material ifrån. Vi har fjorton olika
                            ämnesområden.
                        </div>
                        <div class="font-italic mb-2"> Exempel: Du kan du välja att enbart se material om ämnet
                            Historiska händelser.
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6 mb-3">
                <div class="card">
                    <div class="card-header">
                        <h4>Var</h4>
                    </div>
                    <div class="card-body">
                        <div>Du kan söka på platser genom att skriva vilket ställe du söker.</div>
                        <div class="font-italic mb-2">Exempel: Nya Lapphyttan, Jädersbruks herrgård</div>

                        <div class="mb-2">Du kan använda vår kartfunktion och klicka dig fram till platsen.</div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6 mb-3">
                <div class="card">
                    <div class="card-header">
                        <h4>När</h4>
                    </div>
                    <div class="card-body">
                        <div>Du kan filtrera på vilken tidsperiod du vill se information ifrån. Vi har elva
                            olika tidsperioder.
                        </div>
                        <div class="font-italic mb-2">Exempel: Du kan välja att enbart se material från 1700-talet.
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 text-center mt-3" v-if="noSearchResults">
                <h4 class="text-center">Hittar du fortfarande inte?</h4>
                <div> Det kan vara så att vi ännu inte har material kring det du söker. Lämna gärna ett tips kring vad
                    du
                    önskar se mer av.
                    <a href="/kontakta-oss">Kontaktuppgifter till redaktionen</a></div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
  name: 'SearchTips',

  props: ['noSearchResults']
}
</script>
